export default __webpack_public_path__ + "static/media/Gotham-Thin.defa32b4.ttf";